/**
 * Round down a number to a specified number of decimal places.
 * Avoids converting to string for performance reasons.
 *
 * @param {number} number        The number to round down
 * @param {number} decimalPlaces The number of decimal places to round down to
 * @return {number}               Rounded down number
 */
function roundDown(number, decimalPlaces = 2) {
  const powerOfTen = 10 ** decimalPlaces;
  const adjustedNumber = Math.floor(number * powerOfTen);
  return adjustedNumber / powerOfTen;
}

export default roundDown;
